if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}

export const pushToDataLayer = (event: string, data: Record<string, unknown> = {}): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }
};

export const pushDelayedPageView = (pageReferrer: string): void => {
  if (typeof window === 'undefined') return;

  const checkAndPush = () => {
    pushToDataLayer(AnalyticsEvents.VIRTUAL_PAGE_VIEW, {
      page_location: window.location.href,
      page_title: document.title || 'UP Map',
      page_referrer: pageReferrer
    });
  };

  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(checkAndPush);
};

export const AnalyticsEvents = {
  VIRTUAL_PAGE_VIEW: 'virtual_page_view'
} as const;

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    didomiOnReady: Array<() => void>;
  }
}
